import { motion, Variants } from 'framer-motion';
import { PropsWithChildren } from 'react';

const animations: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

type AnimatedPageProps = PropsWithChildren<{
  duration?: number;
}>;

const AnimatedPage = ({ children, duration = 0.3 }: AnimatedPageProps) => {
  return (
    <motion.div
      variants={animations}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration, ease: 'easeInOut' }}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedPage;
